module.exports = __webpack_public_path__ + "static/media/product-interior.04f0baa3.svg";